// app-user · platform strings: push notifications (explainer screen, Android channels,
// in-app arrival toast), app links (unknown-link notice) and the not-found route.
// The explainer body is the brief's Stage 6 "Notifications (explainer screen)" text.
// Spread into en.ts / bn.ts.
export const appEnPlatform = {
  'app.platform.push.title': 'Know when it’s confirmed',
  'app.platform.push.body': 'Turn on notifications to know when your booking is confirmed or needs action.',
  'app.platform.push.pointConfirmed': 'Your booking is confirmed or changed',
  'app.platform.push.pointPayment': 'Your payment is checked, or a new proof is needed',
  'app.platform.push.pointReminder': 'A reminder before your visit',
  'app.platform.push.cta': 'Turn on notifications',
  'app.platform.push.later': 'Not now',
  'app.platform.push.offNote': 'You can turn them on later in Account.',
  'app.platform.push.channelBookings': 'Bookings',
  'app.platform.push.channelOffers': 'Offers',
  'app.platform.push.arrived': 'New notification',
  'app.platform.push.view': 'View',
  'app.platform.link.bad': 'That link didn’t work. Here’s Home.',
  'app.platform.notFound.title': 'Page not found',
  'app.platform.notFound.body': 'This link may be broken or the page may have moved.',
  'app.platform.notFound.cta': 'Go to Home',
} as const satisfies Record<string, string>;

export const appBnPlatform = {
  'app.platform.push.title': 'নিশ্চিত হলেই জানুন',
  'app.platform.push.body': 'বুকিং নিশ্চিত হলে বা আপনার কিছু করার থাকলে জানতে নোটিফিকেশন চালু করুন।',
  'app.platform.push.pointConfirmed': 'আপনার বুকিং নিশ্চিত বা পরিবর্তন হলে',
  'app.platform.push.pointPayment': 'পেমেন্ট যাচাই হলে, বা নতুন প্রমাণ লাগলে',
  'app.platform.push.pointReminder': 'আপনার ভিজিটের আগে একটি রিমাইন্ডার',
  'app.platform.push.cta': 'নোটিফিকেশন চালু করুন',
  'app.platform.push.later': 'এখন না',
  'app.platform.push.offNote': 'পরে অ্যাকাউন্ট থেকে চালু করতে পারবেন।',
  'app.platform.push.channelBookings': 'বুকিং',
  'app.platform.push.channelOffers': 'অফার',
  'app.platform.push.arrived': 'নতুন নোটিফিকেশন',
  'app.platform.push.view': 'দেখুন',
  'app.platform.link.bad': 'লিংকটি কাজ করেনি। হোমে নিয়ে আসা হলো।',
  'app.platform.notFound.title': 'পেজটি পাওয়া যায়নি',
  'app.platform.notFound.body': 'লিংকটি ভুল হতে পারে, বা পেজটি সরানো হয়েছে।',
  'app.platform.notFound.cta': 'হোমে যান',
} as const satisfies Record<keyof typeof appEnPlatform, string>;
